<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">MESH Neighbor 2.4GHz</h4>
        <el-table :data="tableData.neighbor" border class="fhv-table" size="mini">
            <el-table-column label="MAC Address" prop="mac"></el-table-column>
            <el-table-column label="Mode" prop="mode"></el-table-column>
            <el-table-column label="Tx Packets" prop="txPackets"></el-table-column>
            <el-table-column label="Rx Packets" prop="rxPackets"></el-table-column>
            <el-table-column label="Tx Rate(Mbps)" prop="rate"></el-table-column>
            <el-table-column label="Rssi" prop="rssi"></el-table-column>
            <el-table-column label="Expired Time(s)" prop="expiredTime"></el-table-column>
        </el-table>
        <h4 class="title-topic">MESH Route 2.4GHz</h4>
        <el-table :data="tableData.route" border class="fhv-table" size="mini">
            <el-table-column label="Destination Mesh Point" prop="destMAC" width="180"></el-table-column>
            <el-table-column label="Next-hop Mesh Point" prop="nexthopMAC"></el-table-column>
            <el-table-column label="Portal Enable" prop="portalEnable"></el-table-column>
            <el-table-column label="Metric" prop="metric"></el-table-column>
            <el-table-column label="Hop Count" prop="hopcount"></el-table-column>
        </el-table>
        <h4 class="title-topic">MESH Portal 2.4GHz</h4>
        <el-table :data="tableData.portal" border class="fhv-table" size="mini">
            <el-table-column label="Portal MAC" prop="portalMAC"></el-table-column>
            <el-table-column label="Timeout" prop="timeout"></el-table-column>
            <el-table-column label="SeqNum" prop="seqNum"></el-table-column>
        </el-table>
        <div class="fh-btn-contain">
            <el-button type="primary" @click="getData()">Refresh</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                tableData:{
                    neighbor:[],
                    route:[],
                    portal:[]
                }
            }
        },
        beforeMount(){
             this.getData()
        },
        methods: {
            getData() {
                this.loading = true
                axios
                .post("/boafrm/fhWlanMeshInfo",{wlIndex:'1'})
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret == 0)
                    {
                        this.tableData.neighbor = response.data.meshInfo.neighbor
                        this.tableData.route = response.data.meshInfo.route
                        this.tableData.portal = response.data.meshInfo.portal
                    }
                    else
                        this.$message.error('Get Mesh Info Data Faild!')
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('Get Mesh Info Data Faild!')
                }) 
            }
        },
    }
</script>
